import { type AnyAction, combineReducers } from 'redux';

import type { FontAsset } from 'js/src/client';
import { archiveFontWithId, beginLoadingFonts, storeFonts } from 'js/src/data/fonts/fonts-actions';
import StoreORM from 'js/src/data/store-orm';

export function list(state = StoreORM.newFromIdPrefix<FontAsset>('font').data, action: AnyAction) {
    if (storeFonts.match(action)) {
        const orm = new StoreORM<FontAsset>(state);
        action.payload.fontList.forEach((value) => {
            orm.pushItem(value, 'id');
        });
        return orm.data;
    }
    if (archiveFontWithId.match(action)) {
        const orm = new StoreORM<FontAsset>(state);
        orm.delete([action.payload.fontId]);
        return orm.data;
    }
    return state;
}

export function isLoading(state = false, action: AnyAction) {
    if (beginLoadingFonts.match(action)) {
        return true;
    }
    if (storeFonts.match(action)) {
        return false;
    }
    return state;
}

export const fonts = combineReducers({
    isLoading,
    list,
});

export type FontsState = ReturnType<typeof fonts>;
